export enum UserLogoutTrigger {
  CLICK = 'user_click',
  SESSION_TIMEOUT = 'session_timeout',
}

export enum PaymentMethod {
  APPLE_PAY = 'apple pay',
  CREDIT_CARD = 'credit card',
  GOOGLE_PAY = 'google pay',
}

export enum DataLayerEvent {
  ADD_NEW_CARD_VIEW = 'add_new_card_view',
  ADD_WALLET_NAME_INPUT = 'add_wallet_name_input',
  ADD_WALLET_TICKER_CLICK = 'add_wallet_ticker_click',
  PAY_ATTEMPT = 'pay_attempt',
  BUY_FAIL_START_AGAIN = 'buy_fail_start_again',
  BUY_WIRE_PAYMENT_MADE_CLICK = 'buy_wire_payment_made_click',
  CALCULATE_PROFIT_CLICK = 'calculate_profit_click',
  CHECKOUT = 'checkout',
  CONFIRM_SCREEN_VIEW = 'confirm_screen_view',
  TOS_CONSENT_GIVEN = 'tos_consent_given',
  DELETE_ACCOUNT_VIEW = 'delete_account_view',
  DEPOSIT_ATTEMPT = 'deposit_attempt',
  EMAIL_FAIL = 'email_fail',
  EMAIL_SUCCESS = 'email_success',
  FINISH_TRANSACTION_CLOSE = 'finish_transaction_close',
  FROM_INPUT = 'from_input',
  FROM_METHOD_CHANGE = 'from_method_change',
  FROM_METHOD_VIEW = 'from_method_view',
  FROM_NET_INPUT = 'from_net_input',
  FROM_TICKER_CHANGE = 'from_ticker_change',
  FROM_TICKER_VIEW = 'from_ticker_view',
  HISTORY_EXCHANGE_VIEW = 'history_exchange_view',
  HISTORY_TRANSACTION_VIEW = 'history_transaction_view',
  HISTORY_WALLET_ITEM_VIEW = 'history_wallet_item_view',
  HISTORY_WALLETS_VIEW = 'history_wallets_view',
  KYC_VERIFY_NOW_BUTTON_BANNER_ATTEMPT = 'kyc_verify_now_button_banner_attempt',
  KYC_VERIFY_NOW_BUTTON_SCREEN_ATTEMPT = 'kyc_verify_now_button_screen_attempt',
  LOGIN_SUCCESS = 'login_success',
  LOGOUT_SUCCESS = 'logout_success',
  MARKETING_CONSENT = 'marketing_consent',
  PAGE_MEMBER_EXCHANGE_VIEW = 'exchange_view',
  PAGE_MEMBER_NOTIFICATIONS_VIEW = 'notifications_view',
  PAGE_MEMBER_PROFILE_VIEW = 'profile_view',
  PAGE_MEMBER_SECURITY_VIEW = 'security_view',
  PAGE_MEMBER_TRANSACTION_FUNNEL_VIEW = 'transaction_funnel_view',
  PAGE_MEMBER_TRANSACTIONS_VIEW = 'transactions_view',
  PAYBIS_WALLET_CHANGE = 'paybis_wallet_change',
  PAYBIS_WALLET_VIEW = 'paybis_wallet_view',
  PAYMENT_DETAILS_VIEW = 'payment_details_view',
  PHONE_FAIL = 'phone_fail',
  SMS_OTP_RESEND_CAPTCHA_SUCCESS = 'sms_otp_resend_signup_captcha_success',
  SMS_OTP_SIGNUP_CAPTCHA_FAIL = 'sms_otp_signup_captcha_fail',
  SUBMIT_ATTEMPT = 'submit_attempt',
  TO_EXTERNAL_WALLET_QR_CODE_ATTEMPT = 'to_external_wallet_qr_code_attempt',
  TO_EXTERNAL_WALLET_QR_CODE_SUCCESS = 'to_external_wallet_qr_code_success',
  TO_EXTERNAL_WALLET_VIEW = 'to_external_wallet_view',
  TO_INPUT = 'to_input',
  TO_METHOD_CHANGE = 'to_method_change',
  TO_METHOD_VIEW = 'to_method_view',
  TO_NET_INPUT = 'to_net_input',
  TO_TICKER_CHANGE = 'to_ticker_change',
  TO_TICKER_VIEW = 'to_ticker_view',
  WALLET_ADDED_COPY_ADDRESS = 'wallet_added_copy_address',
  WALLET_ADDED_VIEW = 'wallet_added_view',
  WALLET_BUY_CLICK = 'wallet_buy_click',
  WALLET_CARD_CLICK = 'wallet_card_click',
  WALLET_CHECK_EXPLORER_CLICK = 'wallet_check_explorer_click',
  WALLET_DEPOSIT_CLICK = 'wallet_deposit_click',
  WALLET_RENAME_CLICK = 'wallet_rename_click',
  WALLET_RENAME_VIEW = 'wallet_rename_view',
  WALLET_SELL_CLICK = 'wallet_sell_click',
  WALLET_WITHDRAW_CLICK = 'wallet_withdraw_click',
  WALLETS_ADD_WALLET_CLICK = 'wallets_add_wallet_click',
  WALLETS_BUY_CLICK = 'wallets_buy_click',
  WALLETS_VIEW = 'wallets_view',
  WITHDRAW_ATTEMPT = 'withdraw_attempt',
}

export type DataLayerValue = string | number | boolean | null | undefined;

export interface DataLayerEventPayload {
  [key: string]: DataLayerValue;
}

export enum ExchangeFormSource {
  MAIN_PAGE_PAYBIS = 'main page Paybis',
  MAIN_PAGE_KANO = 'main page Kano',
  MEMBER_AREA = 'member area',
}

export enum EventType {
  METHOD_VIEW = 'methodView',
  METHOD_CHANGE = 'methodChange',
  FIAT_TICKER_VIEW = 'fiatTickerView',
  FIAT_TICKER_CHANGE = 'fiatTickerChange',
  CRYPTO_TICKER_VIEW = 'cryptoTickerView',
  CRYPTO_TICKER_CHANGE = 'cryptoTickerChange',
  SUBMIT_ATTEMPT = 'submitAttempt',
}

export enum TosPrivacyConsentScreenType {
  MID_OTP = 'mid_otp',
  MEMBER_AREA = 'member_area',
}

/** `source` on {@link DataLayerEvent.MARKETING_CONSENT} payloads. */
export enum MarketingConsentSource {
  SIGNUP_EMAIL = 'signup_email',
  MEMBER_BACKFILL = 'member_backfill',
}

export type TypeEventMap = {
  [K in EventType]: Partial<DataLayerEvent>;
}
